import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as jwt_decode from "jwt-decode";
import { Observable } from "rxjs";
import { LocalStorage } from "../helpers/local-storage";
import { DataAccept } from "../interfaces/data-accept.interface";
import { Auth, AuthModel, ConfirmPass, ForgotPass, UpdatePassword } from "../models/auth.models";
import { User } from "../../core/models/user.model";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  user: any;

  optionsHeader = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25"
    })
  };

  private optionsHeaderFormData = {
    headers: new HttpHeaders({
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: "Bearer " + this.getBearerToken()
    })
  };

  constructor(private http: HttpClient) { }

  async auth(data: Auth) {
    const response: any = await this.http.post<AuthModel>("/auth/signin", data, this.optionsHeader).toPromise();

    if (response.user) {
      const user = response.user;
      user.token = response.IdToken;

      LocalStorage.setItem("currentUser", user);
      if (user.group) {
        LocalStorage.setItem("groupUser", user.group);
      }
      return user;
    }

    throw new Error(response.message);
  }

  profile() {
    return this.http.get<User>(`/profile`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: "Bearer " + this.getBearerToken()
      })
    });
  }

  updateProfile(id: string, data: any): Observable<void> {
    return this.http.put<void>(`/profile/${id}/edit`, data, this.optionsHeaderFormData);
  }

  updateProfileImage(id: string, formData: FormData): Observable<any> {
    return this.http.put<any>(`/profile/${id}/image`, formData, this.optionsHeaderFormData);
  }

  forgotPass(data: ForgotPass) {
    return this.http.post<void>(`/auth/forgot-pass`, data, this.optionsHeader);
  }

  confirmPass(data: ConfirmPass) {
    return this.http.post<void>(`/auth/confirm-pass`, data, this.optionsHeader);
  }

  updatePassword(id: string, data: UpdatePassword) {
    return this.http.patch<void>(`/manager/${id}/update-password`, data, {
      headers: new HttpHeaders({
        Authorization: this.getBearerTokenNotAuth()
      })
    });
  }

  termsAccept(data: DataAccept) {
    let token = this.getBearerToken();
    return this.http.post<boolean>(`/terms-conditions/accept`, data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: token
      })
    });
  }

  getIP(): Observable<any> {
    return this.http.get(`https://ipapi.co/json/`, this.optionsHeader);
  }

  getCurrentUser() {
    if (!this.user) {
      this.user = LocalStorage.getItem("currentUser");
    }
    return this.user;
  }

  updateCurrentUser(user) {
    LocalStorage.setItem("currentUser", user);
  }

  getTokenExp(): Date {
    const token = this.getBearerToken();
    if (!token) {
      return null;
    }

    const jwt = jwt_decode(token);
    if (!jwt) {
      return null;
    }

    return new Date(jwt.exp * 1000);
  }

  getBearerToken(): string {
    const user = this.getCurrentUser();

    if (!user) {
      return null;
    }
    return "Bearer " + user.token;
  }

  getBearerTokenNotAuth(): string {
    const token = LocalStorage.getItem("tokenNotAuth");

    if (!token) {
      return null;
    }
    return "Bearer " + token;
  }

  logout() {
    LocalStorage.removeItem("currentUser");
    LocalStorage.removeItem("groupUser");
    LocalStorage.removeItem("apiManualByLogin");
    LocalStorage.removeItem("id");
    this.user = null;
  }
}
